<template>
    <div class="row">
        <div class="col-lg-12 col-md-12 col-12">
            <div class="customer-label-group mb-3">
                <div class="historyheader text-center">
                    Aadhaar Details
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-9 col-md-9 col-12 mx-auto">
            <div class="aadhaar-card-front-outer bg-white">
                <div class="aadhaar-card-header-padding">
                    <div
                        class="d-flex justify-content-between aadhaar-card-header-inner">
                        <div>
                            <img @dragstart.prevent @contextmenu.prevent
                                src="/assets/images/aadhaar-card-images/emblem_black.png"
                                class="" alt style="height: 45px;" />
                        </div>
                        <div>
                            <img @dragstart.prevent @contextmenu.prevent
                                src="/assets/images/aadhaar-card-images/indigovlogo.png"
                                class="" alt style="height: 45px;" />
                        </div>
                        <div>
                            <img @dragstart.prevent @contextmenu.prevent
                                src="/assets/images/aadhaar-card-images/aadharMarathiLogo.png"
                                class="" alt style="height: 45px;" />
                        </div>
                    </div>
                    <div class="aadhaar-card-detail-outer">
                        <div class="d-flex align-items-top">
                            <div class="flex-shrink-0">
                                <img @dragstart.prevent
                                    @contextmenu.prevent
                                    v-if="props.tenantaadhaar.af40 == null || props.tenantaadhaar.af40 == ''"
                                    src="/assets/images/profile.png"
                                    class="aadhaar-image" alt="photo" />
                                <img @dragstart.prevent
                                    @contextmenu.prevent
                                    v-if="props.tenantaadhaar.af40 != null && props.tenantaadhaar.af40 != ''"
                                    :src="state.masterbucketstoragepath + state.master_bucket_aadhaar_photo + '/' + props.tenantaadhaar.af40"
                                    class="aadhaar-image" alt="photo" />
                            </div>
                            <div class="aadhaar-card-detail-inner">
                                <div
                                    class="aadhaar-name text-capitalize">
                                    {{
                                        props.tenantaadhaar.af22
                                            ?
                                            props.tenantaadhaar.af22
                                            :
                                            "N/A"
                                    }}</div>
                                <div class="aadhaar-birthdate">Birth
                                    Date: {{
                                        format_dateonlystamp(props.tenantaadhaar.af23)
                                    }}</div>
                                <div
                                    class="aadhaar-card-logo-outer d-flex justify-content-between">
                                    <div
                                        class="aadhaar-gender text-uppercase">
                                        {{
                                            props.tenantaadhaar.af24
                                                ?
                                                props.tenantaadhaar.af24
                                                    == 1
                                                    ? "Male"
                                                    :
                                                    props.tenantaadhaar.af24
                                                        == 2
                                                        ? "Female"
                                                        : "Others"
                                                : "N/A"
                                        }}</div>
                                    <div>
                                        <img @dragstart.prevent
                                            @contextmenu.prevent
                                            src="/assets/images/aadhaar-card-images/hologramaadhar.png"
                                            class="" alt
                                            style="height: 45px;width: auto;" />
                                    </div>
                                </div>
                                <div class="aadhaar-number">{{
                                    props.tenantaadhaar?.af6
                                        ?
                                        maskedTwelveDigitAadhar(props.tenantaadhaar.af6)
                                        : "N/A" }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="aadhaar-card-footer-padding">
                    <div class="text-center">
                        <img @dragstart.prevent @contextmenu.prevent
                            src="/assets/images/aadhaar-card-images/footer.png"
                            class="" alt style="height: 25px;" />
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-9 col-md-9 col-12 mx-auto">
            <div class="aadhaar-card-back-outer bg-white">
                <div class="aadhaar-card-header-padding">
                    <div
                        class="d-flex justify-content-between aadhaar-card-header-inner">
                        <div>
                            <img @dragstart.prevent @contextmenu.prevent
                                src="/assets/images/aadhaar-card-images/emblem_black.png"
                                class="" alt style="height: 45px;" />
                        </div>
                        <div>
                            <img @dragstart.prevent @contextmenu.prevent
                                src="/assets/images/aadhaar-card-images/indigovlogo.png"
                                class="" alt style="height: 45px;" />
                        </div>
                        <div>
                            <img @dragstart.prevent @contextmenu.prevent
                                src="/assets/images/aadhaar-card-images/aadharMarathiLogo.png"
                                class="" alt style="height: 45px;" />
                        </div>
                    </div>
                    <div class="aadhaar-card-detail-outer">
                        <div class="d-flex align-items-top">
                            <div class="aadhaar-card-detail-inner">
                                <div
                                    class="aadhaar-card-logo-outer d-flex justify-content-between">
                                    <div class="aadhaar-birthdate">
                                        Address: {{
                                            props.tenantaadhaar.af33
                                                ?
                                                props.tenantaadhaar.af33
                                                : "N/A"
                                        }}</div>
                                </div>
                            </div>
                            <div class="flex-shrink-0">
                                <img @dragstart.prevent
                                    @contextmenu.prevent
                                    src="/assets/images/aadhaar-card-images/qr.png"
                                    class="aadhaar-image" alt="photo" />
                            </div>
                        </div>
                        <div class="aadhaar-number text-center">{{
                            props.tenantaadhaar?.af6
                                ?
                                maskedTwelveDigitAadhar(props.tenantaadhaar.af6)
                                : "N/A" }}</div>
                    </div>
                </div>
                <div class="aadhaar-card-footer-padding">
                    <div class="text-center">
                        <img @dragstart.prevent @contextmenu.prevent
                            src="/assets/images/aadhaar-card-images/footer.png"
                            class="" alt style="height: 25px;" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { defineProps, reactive, onMounted } from 'vue';
import commonFunction from "../../composables/commonFunction"
const { format_dateonlystamp, maskedTwelveDigitAadhar } = commonFunction()
import { useStore } from "vuex";
const store = useStore();
const state = reactive({
    masterbucketstoragepath: "",
    master_bucket_aadhaar_photo: '',
})
onMounted(() => {
    const loggedUserData = store.state.loggedInUserSessions;
    if (loggedUserData) {
        state.masterbucketstoragepath = loggedUserData.master_bucket_storage_path;
        state.master_bucket_aadhaar_photo = loggedUserData.master_bucket_aadhaar_photo;
    }
});
const props = defineProps({
    id: {
        type: [String, Number],
        required: true,
    },
    tenantaadhaar: Object,
});

</script>
<style scoped>
.agreement-sub-tab-outer .historyheader {
    color: #0f0f0f;
    font-size: 18px;
    font-family: "OpenSans-Regular";
    line-height: 30px;
    text-align: center;
    margin-bottom: 15px;
}
</style>